import {createSlice, isAnyOf, type SliceSelectors} from '@reduxjs/toolkit'

import {getBankEasyPays, selectFamilyPayPayMethod, selectVirtualAccountPayMethod} from '@web/actions/paymentMethod'
import {restoreSavedState, restoreState} from '@web/actions/restoreState'
import {
    selectRefundAccountsKey,
    selectRefundMethod,
    selectVirtualAccountBankCode,
    updateFamilyPayMemo,
    updateRefundAccounts,
    getInitialState,
} from '@web/slices/payNext/slice'

import type {PayNextReducers, MakeSliceOptions} from './interfaces'
import type {PayNextState} from '@web/slices/payNext/slice'

export default (options?: MakeSliceOptions) =>
    createSlice<PayNextState, PayNextReducers, 'payNext', SliceSelectors<PayNextState>>({
        name: 'payNext',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(selectVirtualAccountBankCode, (state, {payload}) => {
                    state.virtualAccount.selected.code = payload
                })
                .addCase(selectRefundMethod, (state, {payload}) => {
                    state.refund.method = payload
                })
                .addCase(updateRefundAccounts, (state, {payload}) => {
                    state.refund.accounts = payload
                })
                .addCase(selectRefundAccountsKey, (state, {payload}) => {
                    state.refund.selected.accountKey = payload
                })
                .addCase(selectVirtualAccountPayMethod.fulfilled, (state, {payload}) => {
                    state.virtualAccount.selected.code = payload.code ?? state.virtualAccount.selected.code
                })
                .addCase(updateFamilyPayMemo, (state, {payload}) => {
                    if (state.familyPay.memberPaymentInfo) {
                        state.familyPay.memberPaymentInfo.memo = payload
                    }
                })
                .addCase(selectFamilyPayPayMethod.fulfilled, (state, {payload}) => {
                    if (state.familyPay.memberPaymentInfo) {
                        state.familyPay.memberPaymentInfo.memo = payload.memo ?? ''
                    }
                })
                .addCase(getBankEasyPays.fulfilled, (state, {payload}) => {
                    const {
                        refund: {selected},
                    } = state
                    const {bankEasyPays} = payload

                    state.refund.accounts = bankEasyPays.map((account) => {
                        return {
                            ...account,
                            defaultRefundAccount: selected?.accountKey === account.accountKey,
                        }
                    })
                })
            options?.extraReducers?.(builder)
            builder.addMatcher(isAnyOf(restoreSavedState.fulfilled, restoreState), (state, {payload}) => {
                return payload.payNext ?? state
            })
        },
    })
